import { render } from "./SegmentedToggle.vue?vue&type=template&id=128ec35f"
import script from "./SegmentedToggle.vue?vue&type=script&lang=js"
export * from "./SegmentedToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__